type SpecialCreditRecord = {
  redeyecredit?: number | null;
  adg_credit?: number | null;
};

/**
 * Before January 2027 the API returns redeyecredit.
 * From January 2027 it returns adg_credit instead. A record has one of the two.
 */
export const getPairingSpecialCredit = (record?: SpecialCreditRecord | null) => {
  const hasAdg = record && record.adg_credit !== undefined && record.adg_credit !== null;
  const result = hasAdg
    ? { value: Number(record?.adg_credit) || 0, isAdg: true }
    : { value: Number(record?.redeyecredit) || 0, isAdg: false };

  console.log('[ADG/RED credit]', {
    redeyecredit: record?.redeyecredit,
    adg_credit: record?.adg_credit,
    label: result.isAdg ? 'ADG' : 'RED',
    value: result.value
  });

  return result;
};
